module.exports = __webpack_public_path__ + "static/og-87dcbabb9f0ab58592acdf54b3f9b2bd.png";